import NonLoginHeader from '../components/nonLoginHeader'
import Image from '../image/wood.png'
import '../index.scss'
const TopPageElement = () =>{
    return(
        <div className='signInBackGround'>
            <NonLoginHeader/>
            <div className=" px-24 pt-52 mx-auto">
                <div>
                    <img src={Image} alt="Image" className=' left absolute place-content-center top-40 w-72'/>
                    <div className="z-50 left outline-orange-300 top-44 absolute text-2xl text-orange-700 text-shadow-md text-center max-w-xs">
                        Welcome To MealGarage!
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-2 text-center pt-32 mx-auto max-w-sm">
                <a href="#SignIn" className="border-2 text-orange-700 text-shadow bg-orange-400 rounded-md mx-2 px-3">サインイン</a>
                <a href="#SignUp" className="border-2 text-orange-700 text-shadow bg-orange-400 rounded-md mx-2 px-3">サインアップ</a>
            </div>
            <div className="fire">
                <div className="flames">
                    <div className="flame"></div>
                    <div className="flame"></div>
                    <div className="flame"></div>
                    <div className="flame"></div>
                </div>
                <div className="logs"></div>
            </div>
        </div>

    )
}

export default TopPageElement